// extracted by mini-css-extract-plugin
module.exports = {"conclusionPage":"ConclusionPage_conclusionPage__3Ckwy","card":"ConclusionPage_card__1rLvP","content":"ConclusionPage_content__195tD"};